// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._288yA2r2GpDbogdwkS6TV8 {\n    margin-left: 0.5em;\n}\n\n._1lPp5IKDBnSA5ArfIAEMwW {\n    display: flex;\n    flex-direction: row;\n}\n\n._1VcpXgHY7_mWV9DdSNmff5 {\n    cursor: pointer;\n}\n", ""]);
// Exports
exports.locals = {
	"indent": "_288yA2r2GpDbogdwkS6TV8",
	"inline-flex": "_1lPp5IKDBnSA5ArfIAEMwW",
	"pointer": "_1VcpXgHY7_mWV9DdSNmff5"
};
module.exports = exports;
